import axios from "axios";
import { jwtDecode } from "jwt-decode";
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken")
  );
  // Stav pro uchování podrobností o uživateli
  const [userDetails, setUserDetails] = useState({
    userNumber: "",
    name: "",
    role: "",
    mfaSetupBypassed: false,
  });

  const userDetailsRef = useRef({ userNumber: "", name: "", role: "", mfaSetupBypassed: false });

  // Funkce pro dekódování tokenu a získání informací o uživateli
  const decodeToken = (token) => {
    if (token) {
      const decoded = jwtDecode(token);

      const newDetails = {
        userNumber: decoded.userNumber,
        name: decoded.name,
        role: decoded.role,
        mfaSetupBypassed: decoded.mfaSetupBypassed === true,
      };

      userDetailsRef.current = newDetails;
      setUserDetails(newDetails);
    } else {
      userDetailsRef.current = { userNumber: "", name: "", role: "", mfaSetupBypassed: false };
      setUserDetails({ userNumber: "", name: "", role: "", mfaSetupBypassed: false });
      delete axios.defaults.headers.common["Authorization"];
      localStorage.removeItem("token");
    }
  };

  useEffect(() => {
    decodeToken(accessToken);
  }, [accessToken]);

  // Memoizovaná hodnota pro autentizační kontext
  const contextValue = useMemo(
    () => ({
      userDetails,
      setUserDetails,
      accessToken,
      setAccessToken,
    }),
    [accessToken, userDetails]
  );

  // Poskytnutí kontextu child komponentům
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
